"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86735],{

/***/ 551165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Article; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(797864);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(666913);



const StyledCard = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Z)`
  .card-body {
    padding: 1rem 0;
  }
`;
const Article = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ content, title }, ref) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    ref,
    header: title
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .HtmlRenderer */ .V, {
    content
  }));
});
Article.displayName = "Article";




/***/ }),

/***/ 383874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FrameWrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);


const FrameWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div(({ frame }) => `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  background-image: url(${frame});
  background-size: cover;
  height: 100%;
  width: 100%;
  cursor: pointer;
  `);




/***/ }),

/***/ 905958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ImageGallery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(650983);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(732553);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(358277);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(279215);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(885525);
/* harmony import */ var _FrameWrapper_FrameWrapper_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(383874);






const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
`;
const Footer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  bottom: 1rem;
  position: fixed;
  z-index: 3;
  height: fit-content !important;
  padding-bottom: env(safe-area-inset-bottom);
  .swiper-slide {
    width: auto !important;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w)`
  background: #ffffff;
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const StyledSmallImage = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w)`
  background: #ffffff;
`;
const ImageWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  border: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;
const StyledContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  height: calc(100vh - 130px);
  z-index: 4;
  width: 100%;
  > div,
  .swiper-container {
    height: 100%;
    width: 100%;
  }
  .swiper-wrapper {
    height: 100% !important;
    width: 100% !important;
  }
`;
const Thumbnail = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  transition: 0.1s ease opacity;
  text-align: center;
  background-color: transparent;
  width: fit-content !important;
  background: #ffffff;
`;
const ButtonClose = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  position: absolute;
  top: 0;
  left: 0;
  padding: 16px;
  z-index: 1030;
`;
const GalleryIndex = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  right: 16px;
  top: 16px;
  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1030;
`;
const ImageGallery = ({
  images,
  activeImageIndex,
  onClose,
  frame
}) => {
  swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
  const [thumbsSwiper, setThumbsSwiper] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [activeSlideIndex, setActiveSlideIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(activeImageIndex || 0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, onClose && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonClose, {
    onClick: onClose,
    link: true,
    icon: { name: "close", size: 18, color: "#878787" }
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalleryIndex, null, activeSlideIndex + 1, " / ", images.length), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .t, {
    thumbs: { swiper: thumbsSwiper },
    onSlideChange: (swiper) => setActiveSlideIndex(swiper.activeIndex),
    initialSlide: activeImageIndex,
    slidesPerView: 1,
    slidesPerGroup: 1,
    className: "main-images"
  }, images.map((image, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, {
    key: index
  }, frame && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_FrameWrapper_FrameWrapper_es_js__WEBPACK_IMPORTED_MODULE_7__/* .FrameWrapper */ .A, {
    frame
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, {
    contain: true,
    imageWidth: 800,
    src: image.imageUrl,
    alt: image.caption
  })))), !!images.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .t, {
    className: "gallery-thumbs",
    slidesPerView: "auto",
    spaceBetween: 16,
    onSwiper: setThumbsSwiper,
    watchSlidesVisibility: true,
    watchSlidesProgress: true
  }, images.map((image, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Thumbnail, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSmallImage, {
    src: image.thumbnailUrl || image.imageUrl,
    alt: image.caption,
    contain: true,
    width: 60,
    height: 60,
    imageWidth: 150,
    borderRadius: 4
  }))))))));
};




/***/ }),

/***/ 15529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ NavBarDropDown; },
/* harmony export */   "b": function() { return /* binding */ DropDownItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(929556);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(332762);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(437753);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(387100);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Text_Text_es_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(327513);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledDropdown = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Dropdown */ .L)(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, `
width: auto;
`);
const StyledDropdownMenu = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .DropdownMenu */ .h)`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background-color: #fff;
`;
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .SvgIcon */ .l)`
  display: block;
`;
const NavBarDropDown = (_a) => {
  var _b = _a, {
    toggleType = "click",
    toggleIconName = "more",
    items = []
  } = _b, props = __objRest(_b, [
    "toggleType",
    "toggleIconName",
    "items"
  ]);
  const [openPopover, setOpenPopover] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDropdown, __spreadProps(__spreadValues({}, props), {
    isOpen: openPopover,
    toggle: () => setOpenPopover((prev) => !prev),
    toggleType
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .DropdownToggle */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: toggleIconName,
    size: 20,
    color: "#333"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDropdownMenu, null, items.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropDownItem, __spreadProps(__spreadValues({
    key: index
  }, item), {
    prefetch: false
  })))));
};
const ItemWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled.div */ .z.div`
  background-color: #fff;
  text-decoration: none;
`;
const DropDownItem = (_c) => {
  var _d = _c, {
    title,
    iconName
  } = _d, props = __objRest(_d, [
    "title",
    "iconName"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemWrapper, __spreadProps(__spreadValues({}, props), {
    as: props.href ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : "div"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
    justify: "start",
    align: "center",
    flexWrap: "nowrap",
    padding: ["s8", "s12"],
    gap: "s12"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: iconName,
    size: 18
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
    fontSize: 13
  }, title)));
};




/***/ }),

/***/ 964019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ NavBarWithSearchBox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _NavBarDropDown_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15529);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavBarWithSearchBox = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
`;
const Left = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Right = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;
const Center = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`);
const SearchBox = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.input */ .z.input`
  width: 100%;
  height: 2.25rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  outline: none;
`;
const SearchIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)`
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
`;
const CloseIconWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  position: absolute;
  right: 4px;
  top: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const NavBarWithSearchBox = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_a, ref) => {
  var _b = _a, {
    placeholder,
    right,
    goBack,
    clickSearchBox,
    onKeyUp,
    onChange,
    keyword,
    clickClearInput,
    dropdownItems = []
  } = _b, props = __objRest(_b, [
    "placeholder",
    "right",
    "goBack",
    "clickSearchBox",
    "onKeyUp",
    "onChange",
    "keyword",
    "clickClearInput",
    "dropdownItems"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNavBarWithSearchBox, __spreadValues({}, props), goBack && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Left, {
    onClick: goBack
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 24,
    color: "#333"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Center, __spreadValues({
    marginLeft: !goBack ? "16px" : "0px",
    marginRight: !right ? "16px" : "0px"
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchBox",
    target: "searchProduct",
    payload: JSON.stringify(__spreadValues({
      searchKeyword: keyword
    }, typeof window !== "undefined" ? { href: window.location.href, url: window.location.href } : {}))
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIcon, {
    name: "search",
    size: 16
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchBox, {
    ref,
    onKeyUp,
    onClick: clickSearchBox,
    placeholder,
    onChange,
    value: keyword
  }), keyword && clickClearInput && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CloseIconWrapper, {
    onClick: () => {
      clickClearInput();
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, {
    name: "circle-close",
    size: 16
  }))), (right || !!dropdownItems.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, right, !!dropdownItems.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_NavBarDropDown_es_js__WEBPACK_IMPORTED_MODULE_5__/* .NavBarDropDown */ ._, {
    padding: "8px",
    items: dropdownItems
  })));
});
NavBarWithSearchBox.displayName = "NavBarWithSearchBox";




/***/ }),

/***/ 458205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ NavBarWithTitle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _NavBarDropDown_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15529);
/* harmony import */ var _Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(327513);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavBarWithTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);

  &.detail {
    box-shadow: none;
  }
`;
const Left = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => ({
  minWidth: "3.5rem",
  height: "3.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  visibility: props.visible ? "visible" : "hidden"
}));
const Right = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Center = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const NavBarWithTitle = (_a) => {
  var _b = _a, {
    onlyTitle = false,
    title,
    right,
    goBack,
    dropdownItems = []
  } = _b, props = __objRest(_b, [
    "onlyTitle",
    "title",
    "right",
    "goBack",
    "dropdownItems"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNavBarWithTitle, __spreadValues({}, props), !onlyTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Left, {
    visible: !!goBack
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Center, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
    fontWeight: "500",
    maxLines: 1
  }, title)), !onlyTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, right, !!dropdownItems.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_NavBarDropDown_es_js__WEBPACK_IMPORTED_MODULE_4__/* .NavBarDropDown */ ._, {
    padding: "8px",
    items: dropdownItems
  })));
};




/***/ }),

/***/ 558773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ProductHeaderMobile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);



const StyledProductHeader = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: sticky;
  padding: 8px 16px;
  background-color: #fff;
  z-index: 100;
  top: 48px;
  left: 0;
  right: 0;
  width: 100%;
  -webkit-backface-visibility: hidden;
  display: flex;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
  > div {
    &:first-child {
      img {
        width: 32px;
        height: 32px;
      }
    }

    &:nth-child(2) {
      font-size: 12px;
      flex-grow: 2;
      padding: 3px 6px;
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    &:last-child {
      font-weight: 700;
      font-size: 12px;
      white-space: nowrap;
      line-height: 16px;
    }
  }
`;
const ProductHeaderMobile = ({ image, name, price }) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductHeader, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, {
    src: image || "",
    imageWidth: 50,
    width: 32,
    height: 32,
    alt: "productImage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, name), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, price));
};




/***/ }),

/***/ 679311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ProductShortDescriptionMobile; }
/* harmony export */ });
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(781662);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(525369);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(334751);
/* harmony import */ var _Common_Article_Article_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(551165);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(129892);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const NoneDescription = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  color: #848788;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ShortDescription = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Content = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ maxHeight, expanded }) => `
  background-color: #fff;
  height: fit-content;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${expanded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  };
  max-height: ${maxHeight}px;
  padding-bottom: 14px;
  `}
`);
const Wrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
`;
const ShowMore = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .ButtonChevron */ .y)`
  border-radius: 0;
  justify-content: center;
  align-items: center;
  padding: 14px 0;
  color: ${({ showArrow }) => showArrow ? "#848788" : "#0300BE"};
  width: calc(100% - 32px);
  margin: 0 auto;
  margin-top: 14px;
  span {
    margin-left: 4px;
  }

  ${({ theme, variant }) => variant === "ghost" && `
    border-radius: 24px;
    border: 1px solid ${theme.colors.border};
    color: unset;
    padding: 0 1.25rem;
    width: unset;
  `}
`;
const Title = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__["default"].h2`
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
`;
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductShortDescriptionMobile = ({
  description,
  maxHeight,
  expandLabel = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm"),
  collapseLabel = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Thu g\u1ECDn"),
  moveTop = true,
  className,
  title = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("M\xF4 t\u1EA3 s\u1EA3n ph\u1EA9m"),
  isHideTitle = false,
  variant = "link"
}) => {
  const [showMoreNeeded, setShowMoreNeeded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const descriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getElementOffset */ .pW)(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!descriptionRef.current)
      return;
    const ro = new ResizeObserver(() => {
      const el = descriptionRef.current;
      if (!el)
        return;
      !showMoreNeeded && setShowMoreNeeded(el.clientHeight < el.scrollHeight);
    });
    ro.observe(descriptionRef.current);
    return () => ro.disconnect();
  }, [showMoreNeeded]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShortDescription, {
    className
  }, !isHideTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t, {
    hasDivider: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
    ref: descriptionRef,
    maxHeight,
    expanded
  }, description ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_Article_Article_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Article */ .d, {
    content: description
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NoneDescription, null, isHideTitle ? "" : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("src.mobile.ProductDetail.ProductShortDescriptionMobile.0"))), showMoreNeeded && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "descriptionDetail",
    contentName: "viewMore",
    target: "productDescription"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShowMore, {
    block: true,
    variant,
    direction: expanded ? "up" : "down",
    onClick: handleClick,
    showArrow: !isHideTitle
  }, expanded ? collapseLabel : expandLabel))));
};




/***/ }),

/***/ 29978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ProductImagesMobile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(732553);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55257);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var _ImageGallery_ImageGallery_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(905958);
/* harmony import */ var _FrameWrapper_FrameWrapper_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(383874);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const GalleryIndex = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  background-color: #fff;
  position: relative;
`;
const ImageWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  border: 0;
`;
const StyledImage = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const StyledTag = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ color }) => `
  align-items: center;
  display: flex;
  position: absolute;
  z-index: 100;
  left: 16px;
  top: 3px;
  height: 16px;
  font-size: 10px;
  background-color: ${color};
  border-radius: 4px;
  color: #ffffff;
  padding: 0 8px;
  font-weight: 400;
`);
const ProductImagesMobile = ({
  images,
  galleryVisible = false,
  onOpen,
  onClose,
  frame,
  tag,
  sku
}) => {
  const [activeIndexSlide, setActiveIndexSlide] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "imgProductDetail",
    contentName: "viewImage",
    target: "productImage",
    payload: JSON.stringify({
      sku,
      screenName: "productDetail",
      index: activeIndexSlide
    })
  })), tag && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, {
    color: tag.color
  }, tag.value), !galleryVisible && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalleryIndex, null, activeIndexSlide + 1, " / ", images.length), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t, {
    className: "productDetailPreview",
    initialSlide: activeIndexSlide,
    onSlideChange: (swiper) => setActiveIndexSlide(swiper.activeIndex),
    slidesPerView: 1,
    slidesPerGroup: 1
  }, images.map((image) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, {
    key: image.src,
    className: "swiper-slide"
  }, frame && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_FrameWrapper_FrameWrapper_es_js__WEBPACK_IMPORTED_MODULE_5__/* .FrameWrapper */ .A, {
    frame
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, {
    contain: true,
    height: frame ? void 0 : 280,
    imageWidth: 500,
    src: image.src,
    onClick: onOpen
  })))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Overlay */ .a, {
    show: galleryVisible,
    onEscPressed: onClose
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ImageGallery_ImageGallery_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ImageGallery */ .h, {
    onClose,
    images: images.map((image) => ({
      imageUrl: image.src,
      caption: "",
      subCaption: "",
      thumbnailUrl: image.src
    })),
    frame
  })));
};




/***/ }),

/***/ 441682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCheckbox = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, ({ theme, checked, circle, indeterminate = false, width, height }) => {
  const checkedColor = checked || indeterminate ? theme.brand.primary : "#BCBFD6";
  const styles = {
    width,
    height,
    border: circle || !checked ? `1px solid ${checkedColor}` : "none",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    overflow: "hidden"
  };
  if (circle) {
    styles.borderRadius = "50% !important";
  }
  if (checked || indeterminate) {
    styles["&:after"] = {
      content: '" "',
      width: `calc(${width} - ${circle || indeterminate ? 6 : 0}px)`,
      height: `calc(${height} - ${circle || indeterminate ? 6 : 0}px)`,
      backgroundColor: checkedColor,
      borderRadius: circle ? "50%" : "initial"
    };
    if (checked && !circle) {
      styles["&:before"] = {
        position: "absolute",
        display: "table",
        border: "2px solid #fff",
        borderTop: 0,
        borderLeft: 0,
        transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
        transition: "all .2s cubic-bezier(.12,.4,.29,1.46) .1s",
        content: '" "',
        top: "44%",
        left: "50%",
        width: "5px",
        height: "9px",
        transformOrigin: "left top"
      };
    }
  }
  return styles;
});
const Checkbox = (_a) => {
  var _b = _a, {
    className,
    width = "0.9rem",
    height = "0.9rem"
  } = _b, rest = __objRest(_b, [
    "className",
    "width",
    "height"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckbox, __spreadProps(__spreadValues({
    width,
    height
  }, rest), {
    className
  }));
};




/***/ }),

/***/ 432989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ NumberStepperAllowBlank; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72325);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(650983);
/* harmony import */ var _atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(589561);
/* harmony import */ var _contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(580871);







const StyledStepper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ color }) => `
    display: flex;
    align-items: center;
    border-radius: 0.25rem;
    border: 1px solid ${color};
    align-items: center;
    overflow: hidden;
    background: #fff;
    justify-content: space-between;
  `);
const Value = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ color }) => `
    flex: 1;
    color: ${color};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  `);
const StyledButton = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)(({ color }) => `
    line-height: 1;
    color: ${color};
    font-size: 1rem;
    border: none;
    padding: 0;
    align-self: stretch;
    padding: 0.5rem;
    border-radius: 0;
    --button-icon-color: ${color};
`);
const Sign = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
`;
const StyledInput = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I)(({ color }) => `
  padding: 0;
  color: ${color};
  width: 2rem;
  border: none;
  text-align: center;
`);
const Error = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div`
  color: #f60202;
  font-size: 0.75rem;
  margin-top: 2px;
`;
const handleFocus = (event) => event.target.select();
const DELAY = 250;
const NumberStepperAllowBlank = ({
  value,
  minimumValue = 0,
  maximumValue,
  stepValue = 1,
  setValue,
  className,
  showDeleteIcon = false,
  variant = "primary",
  showError = false,
  onKeyPress,
  onRemove,
  disabled = false
}) => {
  const theme = (0,_contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)();
  const color = variant === "primary" ? theme.brand.primary : theme.colors.dark;
  const borderColor = variant === "primary" ? theme.brand.primary : theme.colors.gray300;
  const [inputValue, setInputValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(String(value));
  const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const handleSetValue = (value2) => {
    if (value2 >= minimumValue) {
      setValue(value2);
    }
  };
  const debouncedSetValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(handleSetValue, DELAY), [setValue]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setInputValue(String(value));
  }, [value]);
  const handleChange = (e) => {
    if (e.target.value === "" && minimumValue === 0) {
      setInputValue("0");
      debouncedSetValue(null);
    } else if (!Number(e.target.value) && minimumValue !== 0) {
      setInputValue(String(minimumValue));
      debouncedSetValue(null);
    } else {
      let value2 = parseInt(e.target.value);
      if (value2 >= minimumValue) {
        if (value2 > maximumValue) {
          value2 = maximumValue;
          setError(`B\u1EA1n ch\u1EC9 c\xF3 th\u1EC3 tr\u1EA3 t\u1ED1i \u0111a ${maximumValue} s\u1EA3n ph\u1EA9m`);
        } else {
          setError("");
        }
        setInputValue(String(value2));
        debouncedSetValue(value2);
      }
    }
  };
  const handleDecrease = () => {
    if (inputValue === "" && minimumValue !== 0) {
      setInputValue(String(minimumValue));
      debouncedSetValue(minimumValue);
    } else {
      const currentVal = Number(inputValue);
      const newValue = currentVal - stepValue;
      if (currentVal === minimumValue) {
        onRemove();
      } else if (newValue >= minimumValue) {
        setError("");
        newValue !== 0 ? setInputValue(String(newValue)) : setInputValue("0");
        debouncedSetValue(newValue);
      }
    }
  };
  const handleIncrease = () => {
    if (inputValue === "" && minimumValue !== 0) {
      setInputValue(String(minimumValue));
      debouncedSetValue(minimumValue);
    } else {
      const currentVal = Number(inputValue);
      if (maximumValue >= currentVal + stepValue) {
        setError("");
        setInputValue(String(currentVal + stepValue));
        debouncedSetValue(currentVal + stepValue);
      } else {
        setError(`B\u1EA1n ch\u1EC9 c\xF3 th\u1EC3 tr\u1EA3 t\u1ED1i \u0111a ${maximumValue} s\u1EA3n ph\u1EA9m`);
      }
    }
  };
  const disableIncrease = !!error || Number(inputValue) === maximumValue;
  const disableDecrease = Number(inputValue) === minimumValue;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledStepper, {
    className,
    color: borderColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    color: disableDecrease ? borderColor : color,
    variant,
    outline: true,
    onClick: handleDecrease,
    disabled: !showDeleteIcon && Number(inputValue) === minimumValue,
    icon: inputValue === String(minimumValue) && showDeleteIcon ? {
      name: "trash",
      size: 16
    } : null
  }, (!showDeleteIcon || Number(inputValue) > minimumValue || !inputValue) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sign, null, "-")), setValue ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "number",
    inputMode: "numeric",
    onChange: handleChange,
    value: inputValue,
    onFocus: handleFocus,
    onBlur: () => {
      if (!inputValue || Number(inputValue) < minimumValue) {
        setInputValue(String(minimumValue));
        debouncedSetValue(minimumValue);
      }
    },
    onKeyPress,
    disabled
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Value, null, value), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    color: disableIncrease ? borderColor : color,
    variant,
    outline: true,
    onClick: handleIncrease,
    disabled: disableIncrease
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sign, null, "+"))), error !== "" && showError && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Error, null, error));
};




/***/ })

}]);